import { Action } from '../constants';
const initialState = {
  guide_star_certification_level: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Action.GUIDE_STAR_CERTIFICATION_LEVEL:
      return {
        ...state,
        loading: true,
        guide_star_certification_level: action.payload
      };
    default:
      return state;
  }
};
